<template>
  <div>
    <OffersList
      v-if="!editing"
      :offers="offers"
      :loading="loading"
      @edit="startEdit"
      @create="startCreate"
      @delete="handleDelete"
    />

    <OfferForm
      v-else
      ref="formRef"
      :offer="currentOffer"
      :loading="loading"
      @save="handleSave"
      @cancel="cancelEdit"
    />
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, defineExpose } from 'vue';
import { useOffers } from './composables/useOffers';
import { useEditMode } from './composables/useEditMode';
import OffersList from './components/OffersList.vue';
import OfferForm from './components/OfferForm.vue';

const props = defineProps<{ archived?: boolean }>();
const emit = defineEmits<{ (e: 'archived'): void }>();

const { offers, loading, fetchOffers, saveOffer, deleteOffer } = useOffers({ archived: !!props.archived });
const { editing, currentOffer, startEdit, startCreate, cancelEdit } = useEditMode();

onMounted(() => {
  fetchOffers();
});

const formRef = ref<InstanceType<typeof OfferForm> | null>(null);

const handleSave = async (data: any) => {
  // First persist base offer data
  const res = await saveOffer(data);
  const anyRes = res as any;
  const newId = anyRes?.data?.id ?? anyRes?.id ?? data?.id;
  if (!newId) {
    throw new Error('Brak ID ogłoszenia po zapisie.');
  }
  // Then persist reorder for existing images and upload new files
  await formRef.value?.saveOrder?.(newId);
  await formRef.value?.uploadAll?.(newId);

  cancelEdit();
  await fetchOffers();
};

const handleDelete = async (offer: any) => {
  try {
    await deleteOffer(offer.id);
    await fetchOffers();
    // Inform parent to refresh other lists (e.g., Archiwum)
    emit('archived');
  } catch (error) {
    console.error('Error deleting offer:', error);
    alert('Wystąpił błąd podczas usuwania ogłoszenia');
  }
};

// Expose method for parent to refresh programmatically
defineExpose({ refresh: fetchOffers });
</script>
